module.exports = __webpack_public_path__ + "static/img/fg.053db3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fg.png
// module id = N9yH
// module chunks = 1